import { render, staticRenderFns } from "./RateMarkUpItem.vue?vue&type=template&id=3bd195b5&scoped=true&"
import script from "./RateMarkUpItem.vue?vue&type=script&lang=js&"
export * from "./RateMarkUpItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd195b5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/RateMarkUpItem.vue
// module id = null
// module chunks = 